// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8roLe","right":"styles_right__E9oIc"};